export enum WidgetType {
  // Custom charts
  PIE_CHART, BAR_CHART, SINGLE_METRIC,
  SPIDER_CHART, TAGS, ICONS, TITLE,
  DOUBLE_BAR_CHART,BUBBLE_CHART, TABLE,

  // Socio demo elements
  SOCIODEMO_GENDER, SOCIODEMO_AGE,
  SOCIODEMO_LANGUAGE, SOCIODEMO_PARENTING,
  SOCIODEMO_CHILDREN, SOCIODEMO_RELATION,
  SOCIODEMO_EDUCATION,

  //Persona elements
  PERSONA_SELECTION,PERSONA_STORY,
  PERSONA_PERSONALITY, PERSONA_SUMMARY,
  PERSONA_AUDIENCE,PERSONA_CONTENT,
  PERSONA_SEGMENT, PERSONA_BRANDS,
  PERSONA_REACH, PERSONA_MEDIA,
  PERSONA_EVENTS, PERSONA_PERSONALITIES,
  PERSONA_ORGANIZATIONS,

  //Map elements
  MAP_MAP,MAP_TABLE,

  SIDE_BAR_CHART, SIDE_DOUBLE_BAR_CHART,

  // AI elements
  INSIGHTS_SUMMARY,
  INSPIRATIONAL_CONTENT,
}
